// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1yhAr","select":"Header_select__2A7jl","clinic":"Header_clinic__qLcGw"};